import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getRegistrationById,
  getRegistrationsByEvent,
  updateCompetitorApproval,
  updateRegistrationFiringOrder,
  updateRegistrationRallyNumber,
} from "./registrations.service";

const key = "jeep-rally-registrations";

export const useGetRegistrationsByEvent = (
  eventId,
  params = {},
  options = {}
) => {
  const categoryId = params?.category_id || "";
  const status = params?.status || "";

  return useQuery({
    queryKey: [key, "event", eventId, categoryId, status],
    queryFn: () => {
      const query = {};
      if (categoryId) query.category_id = categoryId;
      if (status) query.status = status;
      return getRegistrationsByEvent(eventId, query);
    },
    enabled: Boolean(eventId) && options.enabled !== false,
    ...options,
  });
};

export const useGetRegistrationById = (id, options = {}) => {
  return useQuery({
    queryKey: [key, id],
    queryFn: () => getRegistrationById(id),
    enabled: Boolean(id) && options.enabled !== false,
    ...options,
  });
};

export const useUpdateCompetitorApprovalMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ registrationId, status }) =>
      updateCompetitorApproval(registrationId, status),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [key] });
    },
  });
};

export const useUpdateFiringOrderMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ registrationId, firing_order }) =>
      updateRegistrationFiringOrder(registrationId, firing_order),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [key] });
    },
  });
};

export const useUpdateRallyNumberMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ registrationId, rally_number }) =>
      updateRegistrationRallyNumber(registrationId, rally_number),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [key] });
    },
  });
};
